import { render, staticRenderFns } from "./Beneficiary.vue?vue&type=template&id=3c9e4267&scoped=true&"
import script from "./Beneficiary.vue?vue&type=script&lang=js&"
export * from "./Beneficiary.vue?vue&type=script&lang=js&"
import style0 from "./Beneficiary.vue?vue&type=style&index=0&id=3c9e4267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e4267",
  null
  
)

export default component.exports